export interface DynamicConfig {
  baseUrl: string
  baseIBKUrl: string
  isProduction: boolean
  env: string
  version: string
  timeout: number
  otpVerificationTimer: number
  otpResendTimer: number
  globalConfigPath: string
}

export const defaultConfig: DynamicConfig = {
  baseUrl: process.env.REACT_APP_baseUrl || "",
  baseIBKUrl: process.env.REACT_APP_baseIBKUrl || "",
  isProduction: process.env.REACT_APP_isProduction === "true",
  env: process.env.REACT_APP_env || "",
  version: process.env.REACT_APP_version || "",
  timeout: Number(process.env.REACT_APP_timeout),
  otpVerificationTimer: Number(process.env.REACT_APP_otpVerificationTimer),
  otpResendTimer: Number(process.env.REACT_APP_otpResendTimer),
  globalConfigPath: String(`${process.env.PUBLIC_URL}/config.json`),
}

export const { globalConfigPath } = defaultConfig

class GlobalConfig {
  config: DynamicConfig = defaultConfig // assign a value because of TypeScript

  public get(): DynamicConfig {
    return this.config
  }

  public set(value: DynamicConfig): void {
    this.config = value
  }
}

export const globalConfig = new GlobalConfig()
